module.exports = __webpack_public_path__ + "static/media/TP_Icon_AnkleSocks.1672bce2.png";